import React, {useMemo} from 'react';
import {useIntl, useSelector,shallowEqual} from 'umi';
import { Switch, H5, Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import '../index.scss';
import { ReactSortable } from 'react-sortablejs';
import {allowShowUserFilter} from "@dbl/core/global";


const RightLayoutTab = (porps: any) => {
  const { handleDragStart, changeShowContact, showContact, hasUserFilter } = porps;
  const { formatMessage } = useIntl();
  const gameCode = useSelector((state) => state.datalab.gameCode, shallowEqual);

  const LayoutElementsList = useMemo(() => ([
    {
      icon: 'tab',
      title: formatMessage({id: 'dbl_create_dashboard_tab'}),
      type: 'tab',
      chartType: 'tab',
      id: 'tab',
    },
    {
      icon: 'text-iocn',
      title: formatMessage({id: 'dbl_create_dashboard_text'}),
      type: 'text',
      chartType: 'text',
      id: 'text',
    },
    {
      icon: 'funnel',
      title: formatMessage({id: 'dbl_filter_general_filter'}),
      type: 'filter',
      chartType: 'filter',
      id: 'filter'
    },
    {
      icon: 'user-filter',
      title: formatMessage({id: 'dbl_filter_user_filter'}),
      type: 'userFilter',
      chartType: 'userFilter',
      id: 'userFilter',
      disabled: hasUserFilter,
      hidden: !allowShowUserFilter(gameCode),
    },
  ]), [formatMessage, hasUserFilter]);

  return (
    <div className="dbl-layout-elements-module">
      <div className="dbl-dashboard-layout-type dbl-config-wrap">
        <H5 className={'dbl-config-wrap-title'}>{formatMessage({id: 'dbl_create_dashboard_basic_components'})}</H5>
        <ReactSortable
          key={'dashboardFilterWrap'}
          group={{
            name: 'dashboardFilterWrap',
            pull: 'clone',
            put: false,
          }}
          // chosen={false}
          // dragClass="dbl-cloneDom-text"
          // ghostClass="dbl-cloneDom-text-gost"
          sort={false}
          filter={'.dbl-elements-disabled'}
          preventOnFilter
          handle={'.dbl-elements'}
          // animation={200}
          // delay={2}
          // forceFallback={true}
          list={LayoutElementsList}
          setList={() => {
          
          }}
          onStart={(evt) => {
            const dragItem = LayoutElementsList[evt.oldIndex];
            if (dragItem?.disabled) {
              evt?.originalEvent?.preventDefault?.();
              evt?.originalEvent?.stopPropagation?.();
              return;
            }
            handleDragStart(dragItem);
          }}
          onEnd={() => {
            handleDragStart(null);
          }}
        >
          {LayoutElementsList.map((item: any) => {
            if (item.hidden) return (<></>);
            return (
              <div
                className={`dbl-elements sortable-filter-${item.id} ${item?.disabled ? 'dbl-elements-disabled' : ''}`}
                key={item.id}
              >
                <SvgIcon className="dbl-elements-icon" type={item?.icon} />
                <span className="dbl-elements-title">{item?.title}</span>
              </div>
            );
          })}
        </ReactSortable>
      </div>
      
      <div className={'dbl-dashboard-show-contact dbl-config-wrap'}>
        <H5 className={'dbl-config-wrap-title'}>{formatMessage({id: 'dbl_common_others'})}</H5>
        <Bubble dark content={formatMessage({id: 'dbl_create_dashboard_show_contact_info'})}>
          <Switch value={showContact} onChange={changeShowContact}>{formatMessage({id: 'dbl_create_dashboard_show_contact'})}</Switch>
        </Bubble>
        
      </div>
    </div>
  );
};

export default RightLayoutTab;
